export default function GuessThreshold () {
    return 0.88
}